import React, { useState } from "react";
import {
  StyleProp,
  ViewStyle,
  View,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import { colors } from "../common/styles/colors";
import { CommonButton } from "./buttons";
import { IconRightShortArrow } from "../common/icons/IconRightShortArrow";
import { IconLeftShortArrow } from "../common/icons/IconLeftShortArrow";

export function PriceAndMenuOptions({
  style,
  data,
}: {
  style?: StyleProp<ViewStyle>;
  data: string[];
}) {
  const [page, setPage] = useState(0);
  return data.length > 4 ? (
    <View style={[{ flexDirection: "row", alignSelf: "stretch" }, style]}>
      {page === 0 &&
        data
          .slice(0, 4)
          .map((it) => (
            <CommonButton
              style={{ marginRight: 8 }}
              containerStyle={styles.smallButton}
              title={it}
              size="small"
              type="whiteFilled"
            />
          ))}
      {page === 0 && (
        <TouchableOpacity
          onPress={() => setPage(1)}
          style={[styles.optionsPageButton, { marginLeft: "auto" }]}
        >
          <IconRightShortArrow fill={colors.black} />
        </TouchableOpacity>
      )}
      {page === 1 && (
        <TouchableOpacity
          onPress={() => setPage(0)}
          style={[styles.optionsPageButton, { paddingLeft: 9 }]}
        >
          <IconLeftShortArrow />
        </TouchableOpacity>
      )}
      {page === 1 &&
        data
          .slice(4)
          .map((it) => (
            <CommonButton
              style={{ marginLeft: 8 }}
              containerStyle={styles.smallButton}
              title={it}
              size="small"
              type="whiteFilled"
            />
          ))}
    </View>
  ) : (
    <View style={[{ flexDirection: "row" }, style]}>
      {data.map((it, index) => (
        <CommonButton
          style={{ marginRight: 8 }}
          containerStyle={styles.smallButton}
          title={it}
          size="small"
          type="whiteFilled"
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  optionsPageButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: "flex-start",
    justifyContent: "center",
    backgroundColor: colors.white,
    paddingLeft: 11,
  },
  smallButton: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    minWidth: 60,
  },
});
